import { render, staticRenderFns } from "./CardAppeal.vue?vue&type=template&id=5694bc0d"
import script from "./CardAppeal.vue?vue&type=script&lang=js"
export * from "./CardAppeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports